import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

// 外部のstore
import affiliate from '@/store/modules/affiliate/index.js';
import ctrl from '@/store/modules/ctrl/index.js';
import subscription from '@/store/modules/subscription/index.js';
import tools01 from '@/store/modules/tools01/index.js';
import tools02 from '@/store/modules/tools02/index.js';

// consts
import Tools02CartSystemConsts from '@/consts/Tools02/CartSystemConsts'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    rootUrl: '',
    rt: '',
    login: 0,
    constData: {},
    userData: {},
    productList: [],
    activePlanData: {},
    stockPoint: 0,
    bonusPointList: [],
    spentAmountsThisMonthInEachTool: [],
    asps: [],
    uploadsFolder: '/uploads/user/active/',
    tool: {}, // 現在のページのtool情報
    // currentPageToolData: {}, // 現在のページのtool情報
    tools: {},
    toolList: [],
    lastVisitedToolCode: '',
    apMinValue: 1000,
    apMaxValue: 50000,
    registeredCardList: [],
    imgLimit: 500000,
    imgLimitMessage: "500KB以下",
    newsOpen: 1,
    backButton: 1,
    QAList: {},
    openSidebar: false,
    apiErrorMessage: "",
    bankAccountTypeList: [],

    //マニュアル目次（量が多いのでマニュアル画面を開いたときだけ取得する）
    manualSectionList: [],
    importErrorTypeList: [],

    domainList: [],

    //mypage
    privilegeList: [],
    privilegeConditionList: [],

    //tools01(mistook...)
    formatEditFrom: '',
    copyPageToolId: '',
    copyPageId: 0
  },
  getters: {
    rootUrl(state) {
      return state.rootUrl
    },
    rt(state) {
      return state.rt
    },
    login(state) {
      return state.login
    },
    constData(state) {
      return state.constData
    },
    toolIdFromToolCode: (state) => (toolCodeKebab) => {
      let toolId = undefined;
      const toolData = state.toolList.find(toolData => toolData.codeKebab === toolCodeKebab);
      if (toolData !== undefined) {
        toolId = toolData.toolId;
      } else {
        // no action.
      }
      return toolId;
    },
    userData(state) {
      return state.userData
    },
    cartDiscardedAspList(state, getters) {
      console.log("--- ↓↓ cartDiscardedAspList ↓↓ ---");

      // 
      let aspList = [];
      let cartSystemAspList = [];

      // 
      for (const aspData of state.asps) {

        // カートの絞り込み
        if (state.subscription.validities.cartSystem === 1) {
          // ok.
        } else {
          if (aspData.isCartSystem === '0') {
            // ok.
          } else {
            continue;
          }
        }

        // 
        if (aspData.isCartSystem === '1') {
          console.log("1");
          console.log(aspData);

          // 
          if (getters['tools02/activeCartSystemSubscriptionData'] !== undefined) {
            console.log("2");
            console.log(getters['tools02/activeCartSystemSubscriptionData']);
            if (getters['tools02/activeCartSystemSubscriptionData'].cartSystemProductId === Tools02CartSystemConsts.PRODUCT_ID_SINGLE_PLAN) {
              console.log("3");
              if (getters['tools02/activeCartSystemSubscriptionData'].aspId === aspData.aspId) {
                console.log("4");
                cartSystemAspList.push(aspData);
              } else {
                console.log("5");
                // no action.
              }
            } else if (getters['tools02/activeCartSystemSubscriptionData'].cartSystemProductId === Tools02CartSystemConsts.PRODUCT_ID_PREMIUM_PLAN) {
              console.log("6");
              cartSystemAspList.push(aspData);
            } else {
              console.log("7");
              // no action.
            }
          } else {
            console.log("8");
            // no action.
          }

          // 
          continue;
        } else {
          console.log("9");
          // no action.
        }

        // 
        aspList.push(aspData);
      }

      // 
      aspList = aspList.concat(cartSystemAspList);

      console.log("--- ↑↑ cartDiscardedAspList ↑↑ ---");

      // 
      return aspList;
    },
    aspList(state, getters) {
      let aspList = [];

      console.log("getters.cartDiscardedAspList");
      console.log(getters.cartDiscardedAspList);

      // 
      for (const aspData of getters.cartDiscardedAspList) {

        // ASP選択で絞り込み
        if (getters.userData.displayAllAsps === true) {
          // ok.
        } else {
          if (getters.userData.displayAspIdList.includes(aspData.aspId) === true) {
            // ok.
          } else {
            continue;
          }
        }

        // 
        aspList.push(aspData);
      }

      // 
      return aspList
    },
    similarAspGroupedAspList(state, getters) {
      let newAspDataList = [];
      let loopIndex = 0;
      let famData = null;
      let famAdIndex = 0;

      let aspList = getters.aspList;

      aspList.forEach((aspData) => {
        //
        if (aspData.aspId === "81") {
          // famのデータを保持
          famData = aspData;
        } else {
          if (aspData.aspId === "7") {
            // famADのindexを記録
            famAdIndex = loopIndex;
          } else {
            //
          }
          newAspDataList.push(aspData);
        }
        loopIndex++;
      });

      //
      if (famData !== null) {
        newAspDataList.splice(famAdIndex + 1, 0, famData);
      } else {
        // no action.
      }

      // 
      return newAspDataList
    },
    asps(state, getters) {
      return getters.aspList
    },
    aspData: (state, getters) => (aspId) => {
      if (aspId === '') {
        return {};
      } else {
        return getters.cartDiscardedAspList.find(aspData => aspData.aspId === aspId);
      }
    },
    aspDataFromAllAspList: (state) => (aspId) => {
      return state.asps.find(aspData => aspData.aspId === aspId);
    },
    bonusPointList(state) {
      return state.bonusPointList
    },
    bonusPointData: (state) => (toolCode, bonusCode) => {
      return state.tools[toolCode].bonusPointList.find(bonusData => bonusData.code === bonusCode);
    },
    stockPoint(state) {
      return state.stockPoint
    },
    productList(state) {
      return state.productList
    },
    activePlanData(state) {
      return state.activePlanData
    },
    spentAmountsThisMonthInEachTool(state) {
      return state.spentAmountsThisMonthInEachTool
    },
    supportingImportAspList(state, getters) {
      let aspList = getters.aspList;
      let supportingImportAspList = [];
      aspList.forEach(aspData => {
        if (aspData.supportsImport === '1') {
          supportingImportAspList.push(aspData);
        } else {
          return;
        }
      });
      return supportingImportAspList;
    },
    aspNames(state) {
      let asps = JSON.parse(JSON.stringify(state.asps));
      let aspNames = [];
      asps.forEach(asp => {
        aspNames[asp.aspId] = asp.aspName;
      });
      return aspNames;
    },
    aspManualUrls(state) {
      let asps = JSON.parse(JSON.stringify(state.asps));
      let aspManualUrls = [];
      asps.forEach(asp => {
        let manualUrls = {
          adminUrl: asp.adminUrl,
          aspPointBackManual: asp.aspPointBackManual,
          aspPnameManual: asp.aspPnameManual,
          pidManualUrl: asp.pidManualUrl
        };
        aspManualUrls[asp.aspId] = manualUrls;
      });
      return aspManualUrls;
    },
    uploadsFolder(state) {
      return state.uploadsFolder
    },
    tool(state) {
      let toolData = state.tool;
      if (state.tool.codeCamel !== '') {
        toolData.id = parseInt(state.tools[state.tool.codeCamel].id);
      } else {
        toolData.id = 0;
      }
      return toolData;
    },
    // currentPageToolData(state) {
    //   return state.currentPageToolData
    // },
    tools(state) {
      return state.tools
    },
    toolData: (state) => (toolId) => {
      toolId = String(toolId);
      return state.toolList.find(toolData => toolData.toolId === toolId);
    },
    toolList(state) {
      return state.toolList
    },
    topPageToolList(state) {
      // 取得
      let topPageToolList = state.toolList.filter((toolData) =>
        toolData.topPage !== "0" && toolData.enable === "1"
      );

      // 並び替え
      topPageToolList = topPageToolList.sort(function (a, b) {
        return a.topPage - b.topPage;
      });

      // 
      return topPageToolList;
    },
    lastVisitedToolCode(state) {
      return state.lastVisitedToolCode
    },
    apMinValue(state) {
      return state.apMinValue
    },
    apMaxValue(state) {
      return state.apMaxValue
    },
    registeredCardList(state) {
      return state.registeredCardList
    },
    imgLimit(state) {
      return state.imgLimit
    },
    imgLimitMessage(state) {
      return state.imgLimitMessage
    },
    imgTotalLimit(state) {
      return state.imgTotalLimit
    },
    imgTotalLimitMessage(state) {
      return state.imgTotalLimitMessage
    },
    imgTotalCount(state) {
      return state.imgTotalCount
    },
    imgTotalCountMessage(state) {
      return state.imgTotalCountMessage
    },
    newsOpen(state) {
      return state.newsOpen
    },
    backButton(state) {
      return state.backButton
    },
    formatEditFrom(state) {
      return state.formatEditFrom
    },
    copyPageInfo(state) {
      let list = {
        id: state.copyPageId,
        toolId: state.copyPageToolId
      }
      return list;
    },
    QAList(state) {
      return state.QAList;
    },
    openSidebar(state) {
      return state.openSidebar;
    },
    apiErrorMessage(state) {
      return state.apiErrorMessage;
    },
    bankAccountTypeList(state) {
      return state.bankAccountTypeList;
    },
    bankAccountTypeData: (state) => (typeId) => {
      let bankAccountTypeData = state.bankAccountTypeList.find(typeData => typeData.typeId === typeId);
      return bankAccountTypeData;
    },
    manualSectionList(state) {
      return state.manualSectionList;
    },
    importErrorTypeList(state) {
      return state.importErrorTypeList;
    },
    domainList(state) {
      return state.domainList;
    },
    domainData: (state) => (id) => {
      const domainData = state.domainList.find(domainData => domainData.id === id);
      return domainData;
    },
    privilegeList(state) {
      return state.privilegeList;
    },
    privilegeConditionList(state) {
      return state.privilegeConditionList;
    },
    conditionGroupedPrivilegeList(state) {
      let conditionGroupedPrivilegeList = [];

      // 
      const privilegeConditionList = JSON.parse(JSON.stringify(state.privilegeConditionList));
      privilegeConditionList.forEach(function (privilegeConditionData) {

        // 
        let privilegeList = state.privilegeList.filter((privilegeData) =>
          privilegeData.conditionId === privilegeConditionData.conditionId &&
          (privilegeData.toolId === String(state.tool.id) || privilegeData.toolId === "0")
        );

        // 
        if (privilegeList.length > 0) {
          privilegeConditionData['privilegeList'] = privilegeList;
          conditionGroupedPrivilegeList.push(privilegeConditionData);
        } else {
          // no action.
        }
      });

      // 
      return conditionGroupedPrivilegeList;
    },
  },
  mutations: {
    setRootUrl(state, payload) {
      state.rootUrl = payload;
    },
    setRt(state, payload) {
      state.rt = payload;
    },
    setConstData(state, payload) {
      state.constData = payload.constData;
    },
    setUserData(state, payload) {
      state.userData = payload;
    },
    setLogin(state, payload) {
      state.login = payload;
    },
    setAsps(state, payload) {
      state.asps = payload;
    },
    setProductList(state, payload) {
      state.productList = payload;
    },
    setActivePlanData(state, payload) {
      state.activePlanData = payload;
    },
    setBonusPointList(state, payload) {
      state.bonusPointList = payload;
    },
    setStockPoint(state, payload) {
      state.stockPoint = payload;
    },
    setSpentAmountsThisMonthInEachTool(state, payload) {
      state.spentAmountsThisMonthInEachTool = payload;
    },
    toggleNewsOpen(state, payload) {
      state.newsOpen = payload;
    },
    setImgLimit(state, payload) {
      state.imgLimit = payload.limit;
      state.imgLimitMessage = payload.mess;
    },
    setImgTotalLimit(state, payload) {
      state.imgTotalLimit = payload.limit;
      state.imgTotalLimitMessage = payload.mess;
    },
    setImgTotalCount(state, payload) {
      state.imgTotalCount = payload.limit;
      state.imgTotalCountMessage = payload.mess;
    },
    toggleOptions(state, payload) {
      state.backButton = payload.backButton;
    },
    setToolData(state, object) {
      state.tool = object;
    },
    // setCurrentPageToolData(state, payload) {
    //   const toolCodeKebab = payload.toolCodeKebab;
    //   const toolList = state.toolList;
    //   const currentPageToolData = toolList.find(toolData => toolData.codeKebab === toolCodeKebab);
    //   state.currentPageToolData = currentPageToolData;
    // },
    setTools(state, array) {
      state.tools = array;
    },
    setToolList(state, array) {
      state.toolList = array;
    },
    setLastVisitedToolCode(state, payload) {
      state.lastVisitedToolCode = payload;
    },
    setApValue(state, payload) {
      state.apMinValue = payload.min;
      state.apMaxValue = payload.max;
    },
    setRegisteredCardList(state, payload) {
      state.registeredCardList = payload;
    },
    setFormatEditFrom(state, payload) {
      state.formatEditFrom = payload;
    },
    setCopyPageInfo(state, payload) {
      state.copyPageToolId = payload.toolId;
      state.copyPageId = payload.id;
    },
    setQAList(state, payload) {
      state.QAList = payload;
    },
    setOpenSidebar(state, payload) {
      state.openSidebar = payload;
    },
    setApiErrorMessage(state, payload) {
      state.apiErrorMessage = payload;
    },
    setBankAccountTypeList(state, payload) {
      state.bankAccountTypeList = payload;
    },
    setManualSectionList(state, payload) {
      state.manualSectionList = payload;
    },
    setImportErrorTypeList(state, payload) {
      state.importErrorTypeList = payload;
    },
    setPrivilegeList(state, payload) {
      state.privilegeList = payload;
    },
    setprivilegeConditionList(state, payload) {
      state.privilegeConditionList = payload;
    },
    setDomainList(state, payload) {
      state.domainList = payload.domainList;
    },
    // setConditionGroupedPrivilegeList(state, payload) {
    //   state.conditionGroupedPrivilegeList = payload;
    // },
  },
  actions: {
    setVariousValuesForAllUsers({
      getters,
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/api/getVariousValue.php`)
          .then(res => {
            console.log(res);

            // commit
            commit('setApiErrorMessage', res.data.apiErrorMessage);
            commit('setBankAccountTypeList', res.data.bankAccountTypeList);
            commit('setImgLimit', {
              limit: res.data.imgLimit,
              mess: res.data.imgLimitMess
            });
            commit('setImgTotalLimit', {
              limit: res.data.imgTotalLimit,
              mess: res.data.imgTotalLimitMess
            });
            commit('setImgTotalCount', {
              limit: res.data.imgTotalCount,
              mess: res.data.imgTotalCountMess
            });
            commit('setApValue', {
              min: res.data.apMinValue,
              max: res.data.apMaxValue
            });
            commit('setTools', res.data.tools);
            commit('setToolList', res.data.toolList);
            commit('setQAList', res.data.qaList);
            commit('setBonusPointList', res.data.bonusPointList);
            commit('setImportErrorTypeList', res.data.importErrorTypeList);
            commit('tools02/setAccountTypeNames', res.data.googleCvAccountTypesNames);

            //dispatch
            dispatch('tools02/setInitialData', res.data.googleCvAccountInitialValues);

            // affiliate
            let payload = {
              rewardFeeWithTax: res.data.affiliateRewardFeeWithTax,
              rewardBorderWithTax: res.data.affiliateRewardBorderWithTax
            };
            commit('affiliate/setConsts', payload);

            //
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject();
          });
      })
    },
    setVariousValuesForLoggedInUser({
      dispatch
    }) {
      dispatch('setUserData');
      dispatch('setLogin', 1);
      // 残ポイント・当月消化ポイント（毎遷移では取得しない方針のため、ログイン時にここで取得する）
      dispatch('setStockPoint');
      dispatch('setSpentAmountsThisMonthInEachTool');
      // setAsps は asps と tools02/autoImportCodes の両方をセットする
      const aspsPromise = dispatch('setAsps');
      dispatch('setActivePlanData');
      dispatch("setRegisteredCardList");
      dispatch('setProductList');
      dispatch("setprivilegeConditionList");
      dispatch("setConstData");
      // commit('setConditionGroupedPrivilegeList');
      const privilegeListPromise = dispatch('setPrivilegeList');
      dispatch("setDomainList");

      // tools01
      dispatch('tools01/setPageList');
      dispatch('tools01/setAbTestList');
      dispatch('tools01/setFormatList');

      // tools02
      dispatch('tools02/setUnits');
      dispatch('tools02/setWithTrashedPromotionList');
      dispatch('tools02/setSubscriptionList');
      dispatch('tools02/setAccounts');
      dispatch('tools02/setPixels');
      dispatch('tools02/setTagList');
      // dispatch('tools02/setUnitList'); // apiがない
      dispatch('tools02/setBussinessAccountList');
      dispatch('tools02/setFacebookEventList');
      dispatch('tools02/setTiktokEventList');
      dispatch('tools02/setLineEventList');
      dispatch('tools02/setYdaEventList');
      dispatch('tools02/setSmartnewsEventList');
      dispatch('tools02/setCartSystemProductList');
      dispatch('tools02/setCartSystemSubscriptionList')
        .then(() => {
          dispatch('subscription/setValidities');
        })
        .catch((error) => {
          console.log(error);
        });
      dispatch('tools02/setParameterPassingLogTypeList');
      dispatch('tools02/setImportResultDefinitionList');

      // affiliate
      dispatch('affiliate/setPrivilegeData');

      // レガシー reload-user-data.php が返していた分 (asp_list / auto_import_codes / privilege_list) は
      // この2つが担うので、呼び出し元が完了を待てるように返す
      return Promise.all([aspsPromise, privilegeListPromise]);
    },
    reloadUserData({
      dispatch
    }) {
      // 各 action が個別にAPIを叩くので、ここでは取りまとめるだけ
      dispatch("setVariousValuesForAllUsers");
      return dispatch("setVariousValuesForLoggedInUser");
    },
    redirect({
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/api/payment/getRetUrl.php`)
          .then(res => {
            console.log(res);
            resolve(res.data);
          })
          .catch(err => {
            console.log(err);
            reject();
          });
      })
    },
    setRootUrl({
      commit
    }) {
      let rootUrl;
      if (
        process.env.NODE_ENV === 'development' ||
        location.host === 'tools.adtasukaru.localhost'
      ) {
        rootUrl = "http://localhost:8001";
      } else {
        if (location.host === 'tools.adtasukaru-wp.com') {
          rootUrl = "https://adtasukaru-wp.com/l";
        } else {
          rootUrl = "https://adtasukaru.com/l";
        }
      }
      commit('setRootUrl', rootUrl);
    },
    setRt({
      commit
    }) {
      let rt;
      if (
        process.env.NODE_ENV === 'development' ||
        location.host === 'tools.adtasukaru.localhost'
      ) {
        rt = "http://adtasukaru.localhost";
      } else {
        if (location.host === 'tools.adtasukaru-wp.com') {
          rt = "https://adtasukaru-wp.com";
        } else {
          rt = "https://adtasukaru.com";
        }
      }
      commit('setRt', rt);
    },
    setUserData({
      commit,
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/l/api/user/get-detail`)
          .then(response => {
            //新方式は成功時に本文へ status を入れない。
            //CheckUserId だけ旧方式 (HTTP 200 + 本文 status:401) のため、本文に status があればセッション切れ
            if (response.data.status === undefined) {
              commit('setUserData', response.data.userData);
              resolve(response);
            } else {
              alert(getters.apiErrorMessage + "(setUserData)");
              resolve(response);
            }
          })
          .catch(error => {
            alert(getters.apiErrorMessage + "(setUserData)");
            reject(error);
          });
      })
    },
    setConstData({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/const/get-data`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            let payload = {
              constData: response.data.data
            };
            commit('setConstData', payload);
          } else {
            console.log(getters.apiErrorMessage + "（setConstData）");
          }
          return;
        })
        .catch((error) => {
          console.log(error);
          return;
        });
    },
    setLogin({
      commit
    }, payload) {
      commit('setLogin', payload);
    },
    setManualSectionList({
      commit,
      getters
    }, toolId) {
      return new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        params.append("tool_id", toolId);
        axios
          .get(`${getters.rt}/l/api/tool/get-manual-section-list`, { params })
          .then((response) => {
            console.log(response);

            //新方式は成功時に本文へ status を入れない。
            //CheckUserId だけ旧方式 (HTTP 200 + 本文 status:401) のため、本文に status があればセッション切れ
            if (response.data.status === undefined) {
              commit('setManualSectionList', response.data.list);
              resolve(response);
            } else {
              alert(response.data.message);
              window.location.href = '/login';
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            alert(getters.apiErrorMessage + "(setManualSectionList)");
            reject(error);
          });
      });
    },
    setAsps({
      commit,
      dispatch,
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/l/api/asp/get-list`)
          .then((response) => {
            if (response.data.status === 200) {
              commit('setAsps', response.data.aspList);

              // 同じレスポンスに autoImportCodes も入っているのでそのまま使う
              dispatch('tools02/setAutoImportCodes', response.data.autoImportCodes);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    setPrivilegeList({
      commit,
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/l/api/privilege/get-user-privilege-list`)
          .then((response) => {
            console.log(response);

            // CheckUserId は未移行 (HTTP 200 + 本文 status:401) なので本文を見る
            if (response.data.status !== 401) {
              commit('setPrivilegeList', response.data.list);
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    setBonusPointList({
      commit
    }, payload) {
      commit('setBonusPointList', payload);
    },
    setStockPoint({
      commit,
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/l/api/point/get-stock-point`)
          .then((response) => {
            console.log(response);
            if (response.data.status === 200) {
              let payload = response.data.stockPoint;
              commit('setStockPoint', payload);
            } else {
              console.log(getters.apiErrorMessage + "（setStockPoint）");
            }
            resolve();
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      })
    },
    setProductList({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/product/get-products-table`)
        .then((res) => {
          console.log(res);
          if (res.data.status === 200) {
            commit('setProductList', res.data.productList);
            return;
          } else {
            alert(getters.apiErrorMessage + "（setProductList）");
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setActivePlanData({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/payment/get-active-plan`)
        .then((response) => {
          console.log(response);
          let payload = response.data.list;
          commit('setActivePlanData', payload);
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setSpentAmountsThisMonthInEachTool({
      commit,
      getters
    }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`${getters.rt}/l/api/point/get-used-point-data`)
          .then((response) => {
            console.log(response);
            let payload = response.data.list;
            commit('setSpentAmountsThisMonthInEachTool', payload);
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      })
    },
    setRegisteredCardList({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/payment/get-registered-card-list`)
        .then((response) => {
          console.log(response);
          if (
            response.data.status === 200 ||
            response.data.status === 400
          ) {
            commit('setRegisteredCardList', response.data.registeredCardList);
            return;
          } else {
            console.log(getters.apiErrorMessage + "（setRegisteredCardList）");
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toggleNewsOpen({
      commit
    }, payload) {
      commit('toggleNewsOpen', payload);
    },
    toggleOptions({
      commit
    }, payload) {
      let backButton;

      switch (payload) {

        // //サイドバーのみ非表示
        // case "Logout":
        //   break;

        // //戻るボタンのみ非表示
        // case "Login":
        //   break;

        //サイドバーと戻るボタン非表示
        case "Logout":
        case "Login":
          backButton = 0;
          break;

        default:
          backButton = 1;
          break;

      }
      commit('toggleOptions', {
        backButton: backButton
      });
    },
    setToolData({
      commit
    }, payload) {
      commit('setToolData', payload);
    },
    // setCurrentPageToolData({
    //   commit
    // }, payload) {
    //   commit('setCurrentPageToolData', payload);
    // },
    setLastVisitedToolCode({
      commit
    }, payload) {
      commit('setLastVisitedToolCode', payload);
    },
    setFormatEditFrom({
      commit
    }, payload) {
      commit('setFormatEditFrom', payload);
    },
    setQAList({
      commit
    }, payload) {
      commit('setQAList', payload);
    },
    switchOpenSidebar({
      commit,
      getters
    }) {
      let payload = getters.openSidebar === true ? false : true;
      commit('setOpenSidebar', payload);
    },





    //mistook...
    setCopyPageInfo({
      commit,
      getters
    }, pageCode) {
      return new Promise((resolve, reject) => {
        let params = new URLSearchParams();
        params.append("page_code", pageCode);
        axios
          .get(`${getters.rt}/l/api/tools01/page/get-data-by-page-code`, { params })
          .then((response) => {
            console.log(response);
            //新方式は成功時に本文へ status を入れない。
            //CheckUserId だけ旧方式 (HTTP 200 + 本文 status:401) のため、本文に status があればセッション切れ
            if (response.data.status === undefined) {
              let payload = {
                'toolId': response.data.toolId,
                'id': response.data.siteId
              }
              commit('setCopyPageInfo', payload);
              resolve();
            } else {
              //この store は router を持たないので、リダイレクトは呼び出し側に任せる
              alert(response.data.message);
              reject();
            }
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      })
    },
    setprivilegeConditionList({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/privilege/get-condition-list`)
        .then((res) => {
          console.log(res);
          if (res.data.status === 200) {
            commit('setprivilegeConditionList', res.data.privilegeConditionList);
            return;
          } else {
            console.log(getters.apiErrorMessage + "（setprivilegeConditionList）");
            return;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // checkAndGivesBonusPoint({
    //   getters,
    //   dispatch
    // }, payload) {
    //   return new Promise((resolve, reject) => {
    //     let params = new URLSearchParams();
    //     params.append("bonus_id", payload.bonusId);
    //     axios
    //       .post(`${getters.rt}/api/checkAndGivesBonusPoint.php`, params)
    //       .then(response => {
    //         console.log(response);
    //         if (response.data.status === 200) {
    //           dispatch("setUserData");
    //         } else {
    //           // 
    //         }
    //         resolve();
    //       })
    //       .catch(error => {
    //         console.log(error);
    //         reject();
    //       });
    //   })
    // },
    setDomainList({
      commit,
      getters
    }) {
      axios
        .get(`${getters.rt}/l/api/domain/get-list`)
        .then((response) => {
          console.log(response);
          if (response.data.status === 200) {
            const payload = {
              domainList: response.data.list
            };
            commit('setDomainList', payload);
          } else {
            console.log(getters.apiErrorMessage + "（setDomainList）");
          }
          return;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  plugins: [
    createPersistedState(),
  ],
  modules: {
    affiliate,
    ctrl,
    subscription,
    tools01,
    tools02,
  }
})